export default __webpack_public_path__ + "static/media/usersuccess.433e99a3.svg";